import { defineMessages } from 'react-intl';

export default defineMessages({
  settings: {
    id: 'settings',
    description: 'settings',
    defaultMessage: 'Settings',
  },
  helpCenter: {
    id: 'helpCenter',
    description: 'Help Center',
    defaultMessage: 'Help Center',
  },
});
